import {
    FormFieldSelect,
    FormFieldSwitchSelect,
    FormFieldTime,
} from 'global/components/Form'
import Grid from 'global/components/ui/Grid'
import { UserXIcon } from 'lucide-react'
import { useFormContext } from 'react-hook-form'
import {
    type CondicaoUi,
    descreverLimite,
    OPCOES_COMPARACAO,
} from './condicao-ui'

const ROTULO_TIPO_FALTA: Record<string, string> = {
    integral: 'Integral',
    parcial: 'Parcial',
    justificada: 'Justificada',
    injustificada: 'Injustificada',
    qualquer: 'Qualquer',
}

const OPCOES_TIPO_FALTA = Object.entries(ROTULO_TIPO_FALTA).map(
    ([value, label]) => ({ value, label }),
)

function ParametrosFalta() {
    const { setValue } = useFormContext()

    return (
        <Grid container>
            <Grid item xs={12} sm={4}>
                <FormFieldSelect
                    name="parametros.tipo"
                    label="Tipo de falta"
                    options={OPCOES_TIPO_FALTA}
                />
            </Grid>
            <Grid item xs={6} sm={4}>
                <FormFieldSwitchSelect
                    name="parametros.comparacao"
                    label="Duração"
                    options={OPCOES_COMPARACAO}
                />
            </Grid>
            <Grid item xs={6} sm={4}>
                <FormFieldTime
                    name="parametros.limite"
                    label="Limite"
                    // Opcional: campo apagado volta a "qualquer duração"
                    // em vez de virar '' e falhar no formato HH:mm.
                    onChange={hora => {
                        if (!hora) setValue('parametros.limite', undefined)
                    }}
                />
            </Grid>
        </Grid>
    )
}

export const falta: CondicaoUi = {
    icone: UserXIcon,
    parametrosIniciais: { tipo: 'integral', comparacao: 'acima' },
    Parametros: ParametrosFalta,
    resumir: parametros => {
        const tipo = ROTULO_TIPO_FALTA[String(parametros.tipo)] ?? ''
        return parametros.limite
            ? `${tipo} · ${descreverLimite(parametros)}`
            : tipo
    },
}
